// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/**
 * The SOP detail page for `sopId`. `siteId` is the site the SOP was opened from
 * (an alarm's or anomaly's): with ADM on (AB#33803) the SOP is read per site, and
 * `/sops/:id` is not under a site, so the link carries it. Without one the page
 * falls back to the selected site.
 */
export function sopDetailPath(sopId: string, siteId?: string): string {
  const site = siteId ? `?site=${encodeURIComponent(siteId)}` : '';
  return `/sops/${encodeURIComponent(sopId)}${site}`;
}
